import {
  Account,
  Identifiable,
  List,
  PersonalSynthesis,
  Project,
  Resource,
  Task,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  delayedTasks: (Identifiable<Task> & {
    activity: Identifiable<List> & {
      project: Identifiable<Project>;
    };
  })[];
  comingTasks: (Identifiable<Task> & {
    activity: Identifiable<List> & {
      project: Identifiable<Project>;
    };
  })[];
  delayedTasksNbr: number;
  openedTasksNbr: number;
  completedTasksNbr: number;
  allocatedTasksNbr: number;
};

function responseToSynthesis(res: Response): PersonalSynthesis {
  return {
    upComingTasks: res.comingTasks.map((task) => ({
      ...task,
      list: task.activity,
      allocations: task.allocations,
    })),
    overDueTasks: res.delayedTasks.map((task) => ({
      ...task,
      list: task.activity,
      allocations: task.allocations,
    })),
    delayedTasksNbr: res.delayedTasksNbr,
    openedTasksNbr: res.openedTasksNbr,
    completedTasksNbr: res.completedTasksNbr,
    allocatedTasksNbr: res.allocatedTasksNbr,
  };
}

function getPersonalSynthesis(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources/${resource.uuid}?projection=synthesis`,
        method: HttpMethods.GET,
      })
      .then(responseToSynthesis);
}

export { getPersonalSynthesis };
